document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const safeStorage = {
    getItem(key) { try { return localStorage.getItem(key); } catch { return null; } },
    setItem(key, value) { try { localStorage.setItem(key, value); } catch {} }
  };
  const introGate = document.querySelector('[data-intro-gate]');
  if (introGate) {
    const hideReturning = introGate.dataset.hideReturning === 'true';
    const hasVisited = safeStorage.getItem('xarchive-intro-seen') === 'true';
    const enterButton = introGate.querySelector('[data-intro-enter]');
    const skipButton = introGate.querySelector('[data-intro-skip]');
    const progress = introGate.querySelector('[data-intro-progress]');
    let progressValue = 0;

    const closeIntro = (destination) => {
      safeStorage.setItem('xarchive-intro-seen', 'true');
      if (progress) progress.style.width = '100%';
      introGate.classList.add('is-hidden');
      introGate.setAttribute('aria-hidden', 'true');
      introGate.inert = true;
      document.body.classList.remove('intro-is-open');
      introGate.querySelectorAll('video').forEach(video => video.pause());
      window.setTimeout(() => { introGate.hidden = true; }, 850);
      if (destination) window.setTimeout(() => { window.location.href = destination; }, 520);
    };

    if ((hasVisited && hideReturning) || window.Shopify?.designMode) {
      introGate.classList.add('is-hidden');
      introGate.hidden = true;
      introGate.setAttribute('aria-hidden', 'true');
      introGate.inert = true;
      introGate.querySelectorAll('video').forEach(video => video.pause());
    } else {
      introGate.removeAttribute('aria-hidden');
      introGate.inert = false;
      document.body.classList.add('intro-is-open');
      const progressTimer = window.setInterval(() => {
        progressValue = Math.min(progressValue + 1.4, 92);
        if (progress) progress.style.width = `${progressValue}%`;
      }, 100);
      const enter = () => {
        window.clearInterval(progressTimer);
        const destination = enterButton?.dataset.introLink || '';
        closeIntro(destination);
      };
      enterButton?.addEventListener('click', enter);
      skipButton?.addEventListener('click', () => {
        window.clearInterval(progressTimer);
        closeIntro('');
      });
      introGate.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...introGate.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(element => !element.disabled);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
  }

  const customCursor = document.querySelector('[data-custom-cursor]');
  if (customCursor && window.matchMedia('(pointer: fine)').matches && !prefersReducedMotion.matches) {
    // Keep the native cursor as a reliable fallback; this ring is a visual accent.
    let cursorFrame;
    document.addEventListener('pointermove', (event) => {
      cancelAnimationFrame(cursorFrame);
      cursorFrame = requestAnimationFrame(() => {
        customCursor.style.left = `${event.clientX}px`;
        customCursor.style.top = `${event.clientY}px`;
        customCursor.classList.add('is-visible');
      });
    }, { passive: true });
    document.addEventListener('mouseover', (event) => {
      const target = event.target?.closest?.('a, button, input, textarea, select, summary, [data-cursor-hover]');
      customCursor.classList.toggle('is-hover', Boolean(target));
    });
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    const cartPanel = cartDrawer.querySelector('.cart-drawer__panel');
    const cartBody = cartDrawer.querySelector('[data-cart-drawer-body]');
    const cartStatus = cartDrawer.querySelector('[data-cart-drawer-status]');
    const currencyCode = cartDrawer.dataset.currency || window.Shopify?.currency?.active || 'USD';
    const checkoutUrl = cartDrawer.dataset.checkoutUrl || '/checkout';
    const shopUrl = cartDrawer.dataset.shopUrl || '/collections/all';
    let lastCartTrigger;
    let cartRequest;

    const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
    const formatMoney = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currencyCode }).format(Number(cents || 0) / 100); }
      catch { return `${(Number(cents || 0) / 100).toFixed(2)} ${currencyCode}`; }
    };
    const setCartCount = count => {
      document.querySelectorAll('[data-cart-count], [data-drawer-count]').forEach(element => { element.textContent = `(${count})`; });
    };
    const itemMarkup = (item, index) => {
      const line = index + 1;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : '';
      const image = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : '';
      return `<article class="cart-drawer-item" data-cart-drawer-item>
        <a class="cart-drawer-item__image" href="${escapeHTML(item.url)}">${image}</a>
        <div class="cart-drawer-item__info">
          <a href="${escapeHTML(item.url)}"><h3>${escapeHTML(item.product_title)}</h3></a>
          ${variant}
          <strong>${formatMoney(item.final_line_price)}</strong>
          <div class="cart-drawer-item__actions">
            <div class="cart-drawer-quantity" aria-label="Quantity for ${escapeHTML(item.product_title)}">
              <button type="button" data-drawer-quantity data-line="${line}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <input type="number" value="${item.quantity}" min="0" inputmode="numeric" data-drawer-quantity-input data-line="${line}" aria-label="Quantity">
              <button type="button" data-drawer-quantity data-line="${line}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="cart-drawer-item__remove" data-drawer-remove data-line="${line}">REMOVE</button>
          </div>
        </div>
      </article>`;
    };
    const renderCart = cart => {
      setCartCount(cart.item_count);
      if (!cart.item_count) {
        cartBody.innerHTML = `<div class="cart-drawer__empty"><p>YOUR CART IS EMPTY.</p><p class="cart-drawer__empty-note">ADD SOME PIECES YOU LOVE.</p><a class="button" href="${shopUrl}">SHOP THE ARCHIVE</a></div>`;
        return;
      }
      cartBody.innerHTML = `<div class="cart-drawer__items">${cart.items.map(itemMarkup).join('')}</div>
        <div class="cart-drawer__footer"><div class="cart-drawer__total"><span>SUBTOTAL</span><strong>${formatMoney(cart.total_price)}</strong></div>
        <p>Taxes and shipping calculated at checkout.</p><a class="button button--full" href="${checkoutUrl}">CHECKOUT</a><a class="cart-drawer__continue" href="${shopUrl}">FIND YOUR NEXT FAVE ↗</a></div>`;
    };
    const refreshCart = async () => {
      cartRequest?.abort();
      cartRequest = new AbortController();
      const response = await fetch('/cart.js', { signal: cartRequest.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };
    const openCart = async trigger => {
      lastCartTrigger = trigger || document.activeElement;
      cartDrawer.hidden = false;
      document.body.classList.add('cart-drawer-is-open');
      requestAnimationFrame(() => cartDrawer.classList.add('is-open'));
      try { await refreshCart(); }
      catch { if (cartStatus) cartStatus.textContent = 'Unable to load your cart. Please try again.'; }
      cartPanel?.focus({ preventScroll: true });
    };
    const closeCart = () => {
      cartDrawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-is-open');
      window.setTimeout(() => { if (!cartDrawer.classList.contains('is-open')) cartDrawer.hidden = true; }, 350);
      if (lastCartTrigger?.isConnected) lastCartTrigger.focus({ preventScroll: true });
    };
    const changeLine = async (line, quantity) => {
      if (cartStatus) cartStatus.textContent = 'Updating cart…';
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) }) });
        if (!response.ok) throw new Error('Cart update failed');
        renderCart(await response.json());
        if (cartStatus) cartStatus.textContent = 'Cart updated.';
      } catch { if (cartStatus) cartStatus.textContent = 'Unable to update your cart. Please try again.'; }
    };
    const addToCart = async form => {
      const submit = form.querySelector('[data-product-submit], .quick-add-button[type="submit"], button[type="submit"]');
      const originalText = submit?.textContent;
      if (submit) { submit.disabled = true; submit.textContent = 'ADDING…'; }
      form.classList.add('is-loading');
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Add to cart failed');
        await openCart(submit);
      } catch { if (cartStatus) cartStatus.textContent = 'That item could not be added. Please try again.'; }
      finally { form.classList.remove('is-loading'); if (submit) { submit.disabled = false; submit.textContent = originalText; } }
    };
    const bindProductForms = (root = document) => root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (form.dataset.cartBound) return;
      form.dataset.cartBound = 'true';
      form.addEventListener('submit', event => {
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        addToCart(form);
      });
    });

    document.querySelectorAll('[data-cart-toggle]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); openCart(link); }));
    cartDrawer.addEventListener('click', event => {
      if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
      const quantityButton = event.target.closest('[data-drawer-quantity]');
      if (quantityButton) { changeLine(quantityButton.dataset.line, quantityButton.dataset.quantity); return; }
      const removeButton = event.target.closest('[data-drawer-remove]');
      if (removeButton) changeLine(removeButton.dataset.line, 0);
    });
    cartDrawer.addEventListener('change', event => {
      const input = event.target.closest('[data-drawer-quantity-input]');
      if (input) changeLine(input.dataset.line, input.value);
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCart(); });
    bindProductForms();
    document.addEventListener('shopify:section:load', event => bindProductForms(event.target));
  }

  document.querySelectorAll('[data-search-form]').forEach((form) => {
    const input = form.querySelector('[data-search-input]');
    const clear = form.querySelector('[data-search-clear]');
    const submit = form.querySelector('[data-search-submit]');
    const panel = form.querySelector('[data-search-suggestions]');
    const results = form.querySelector('[data-search-results]');
    const count = form.querySelector('[data-search-count]');
    const status = form.parentElement?.querySelector('[data-search-status]');
    if (!input || !panel || !results) return;
    let timer;
    let request;
    let active = -1;

    const setOpen = (open) => {
      panel.hidden = !open;
      input.setAttribute('aria-expanded', String(open));
    };
    const setStatus = (message) => { if (status) status.textContent = message; };
    const showActive = () => {
      const options = [...results.querySelectorAll('[role="option"]')];
      options.forEach((option, index) => option.classList.toggle('is-active', index === active));
      input.setAttribute('aria-activedescendant', active >= 0 && options[active] ? options[active].id : '');
    };
    const render = (products) => {
      results.replaceChildren();
      active = -1;
      if (!products.length) {
        count.textContent = '0 FOUND';
        results.innerHTML = '<span class="search-suggestions__empty">NO MATCHES YET — PRESS SEARCH TO OPEN THE ARCHIVE.</span>';
        setOpen(true);
        return;
      }
      count.textContent = `${products.length} FOUND`;
      products.forEach((product, index) => {
        const link = document.createElement('a');
        link.className = 'search-suggestion';
        link.id = `SearchSuggestion-${index}`;
        link.href = product.url || '/';
        link.setAttribute('role', 'option');
        const image = product.featured_image || product.image;
        if (image) {
          const artwork = document.createElement('img');
          artwork.src = typeof image === 'string' ? image : image.url || image.src || '';
          artwork.alt = '';
          artwork.loading = 'lazy';
          if (artwork.src) link.append(artwork);
        }
        const name = document.createElement('span');
        name.textContent = product.title || 'ARCHIVE ITEM';
        link.append(name);
        if (product.price) {
          const price = document.createElement('small');
          price.textContent = product.price;
          link.append(price);
        }
        results.append(link);
      });
      setOpen(true);
    };
    const loadSuggestions = async () => {
      const query = input.value.trim();
      clear.hidden = !query;
      if (query.length < 2) {
        request?.abort(); results.replaceChildren(); setOpen(false); setStatus(''); return;
      }
      request?.abort();
      request = new AbortController();
      setStatus('SEARCHING THE ARCHIVE…');
      count.textContent = '…';
      setOpen(true);
      try {
        const endpoint = new URL('/search/suggest.json', window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '6');
        endpoint.searchParams.set('resources[options][unavailable]', 'show');
        const response = await fetch(endpoint, { signal: request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        render(products);
        setStatus(products.length ? `${products.length} live matches` : 'No live matches');
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.replaceChildren(); setOpen(false); setStatus('Press SEARCH to browse results.');
      }
    };
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      window.clearTimeout(form.searchTimer);
      form.searchTimer = window.setTimeout(loadSuggestions, 180);
    });
    input.addEventListener('focus', () => { if (results.children.length) setOpen(true); });
    input.addEventListener('keydown', (event) => {
      const options = [...results.querySelectorAll('[role="option"]')];
      if (event.key === 'Escape') { setOpen(false); return; }
      if (!options.length || panel.hidden) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); active = (active + 1) % options.length; showActive(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); active = (active - 1 + options.length) % options.length; showActive(); }
      if (event.key === 'Enter' && active >= 0) { event.preventDefault(); options[active].click(); }
    });
    clear?.addEventListener('click', () => {
      input.value = ''; clear.hidden = true; results.replaceChildren(); setOpen(false); setStatus(''); input.focus();
    });
    form.addEventListener('submit', () => {
      setOpen(false); setStatus('OPENING THE ARCHIVE…');
      if (submit) { submit.disabled = true; submit.textContent = 'OPENING…'; }
    });
    document.addEventListener('pointerdown', (event) => { if (!form.contains(event.target)) setOpen(false); }, { passive: true });
    clear.hidden = !input.value;
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      form?.classList.add('is-loading');
      select.setAttribute('aria-busy', 'true');
      if (form?.requestSubmit) form.requestSubmit();
      else form?.submit();
    });
  });

  document.querySelectorAll('.cart-form [data-cart-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('input[type="number"]');
      if (!input) return;
      const next = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(button.dataset.cartStep || 0));
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.closest('.cart-item')?.classList.add('is-changing');
      window.setTimeout(() => input.closest('.cart-item')?.classList.remove('is-changing'), 420);
    });
  });


  document.querySelectorAll('.faq-item').forEach((item) => {
    item.addEventListener('toggle', () => {
      const symbol = item.querySelector('summary span');
      if (symbol) symbol.textContent = item.open ? '−' : '+';
    });
  });

  document.querySelectorAll('[data-music-player]').forEach((player) => {
    const music = player.querySelector('#xarchive-music');
    const toggles = player.querySelectorAll('[data-music-toggle]');
    const states = player.querySelectorAll('[data-music-state]');
    const title = player.querySelector('[data-music-title]');
    const tracks = [...player.querySelectorAll('[data-music-track]')];
    const previous = player.querySelector('[data-music-prev]');
    const next = player.querySelector('[data-music-next]');
    const playlistToggle = player.querySelector('[data-music-playlist-toggle]');
    const playlist = player.querySelector('[data-music-playlist]');
    let currentPosition = Number.parseInt(safeStorage.getItem('xarchive-music-track') || '0', 10);

    if (!music || !tracks.length) return;
    if (!tracks[currentPosition]) currentPosition = 0;

    const updateMusicState = () => {
      const playing = !music.paused;
      states.forEach((state) => { state.textContent = playing ? 'PAUSE' : 'PLAY'; });
      toggles.forEach((toggle) => {
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.setAttribute('aria-label', playing ? 'Pause music' : 'Play music');
      });
      player.classList.toggle('is-playing', playing);
    };

    const loadTrack = (index, shouldPlay = false) => {
      const track = tracks[(index + tracks.length) % tracks.length];
      currentPosition = tracks.indexOf(track);
      music.src = track.dataset.trackUrl;
      music.load();
      if (title) title.textContent = track.dataset.trackTitle;
      tracks.forEach((option) => option.classList.toggle('is-active', option === track));
      safeStorage.setItem('xarchive-music-track', String(currentPosition));
      if (shouldPlay) music.play().catch(() => updateMusicState());
      updateMusicState();
    };

    loadTrack(currentPosition);

    toggles.forEach((toggle) => toggle.addEventListener('click', async () => {
      if (music.paused) {
        try { await music.play(); } catch (error) { states.forEach((state) => { state.textContent = 'TAP AGAIN'; }); }
      } else music.pause();
      updateMusicState();
    }));
    previous?.addEventListener('click', () => loadTrack(currentPosition - 1, !music.paused));
    next?.addEventListener('click', () => loadTrack(currentPosition + 1, !music.paused));
    tracks.forEach((track, index) => track.addEventListener('click', () => loadTrack(index, true)));
    playlistToggle?.addEventListener('click', () => {
      const isOpen = playlistToggle.getAttribute('aria-expanded') === 'true';
      playlistToggle.setAttribute('aria-expanded', String(!isOpen));
      if (playlist) playlist.hidden = isOpen;
    });
    music.addEventListener('play', updateMusicState);
    music.addEventListener('pause', updateMusicState);
    music.addEventListener('ended', () => loadTrack(currentPosition + 1, true));
  });

  const progress = document.querySelector('[data-scroll-progress]');
  const updateScrollProgress = () => {
    if (!progress) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.width = `${max > 0 ? (window.scrollY / max) * 100 : 0}%`;
  };
  updateScrollProgress();
  window.addEventListener('scroll', updateScrollProgress, { passive: true });

  const motionItems = document.querySelectorAll('.section-heading, .hero-content, .product-card, .lookbook-card, .collection-list-card, .image-split__content, .faq-item, .newsletter-inner, .newsletter-form, .search-form, .search-summary, .collection-toolbar, .cart-item, .cart-summary, .contact-form, .empty-state, .product-meta details');
  if (motionItems.length && 'IntersectionObserver' in window && !window.Shopify?.designMode && document.body.dataset.productMotion !== 'false' && !prefersReducedMotion.matches) {
    document.body.classList.add('motion-ready');
    motionItems.forEach((item, index) => {
      item.classList.add('motion-item');
      item.style.setProperty('--motion-delay', `${Math.min(index % 6, 5) * 55}ms`);
    });
    const motionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -3% 0px' });
    motionItems.forEach((item) => motionObserver.observe(item));
  }

  document.querySelectorAll('[data-spotlight]').forEach((section) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    section.addEventListener('pointermove', (event) => {
      const bounds = section.getBoundingClientRect();
      section.style.setProperty('--pointer-x', `${((event.clientX - bounds.left) / bounds.width) * 100}%`);
      section.style.setProperty('--pointer-y', `${((event.clientY - bounds.top) / bounds.height) * 100}%`);
    });
  });

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const target = new Date(countdown.dataset.countdownDate).getTime();
    if (Number.isNaN(target)) return;
    const days = countdown.querySelector('[data-countdown-days]');
    const hours = countdown.querySelector('[data-countdown-hours]');
    const minutes = countdown.querySelector('[data-countdown-minutes]');
    const seconds = countdown.querySelector('[data-countdown-seconds]');
    const pad = (value) => String(value).padStart(2, '0');
    const updateCountdown = () => {
      const remaining = Math.max(target - Date.now(), 0);
      const totalSeconds = Math.floor(remaining / 1000);
      if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
      if (hours) hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (seconds) seconds.textContent = pad(totalSeconds % 60);
    };
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const wrapper = carousel.closest('.section');
    const previous = wrapper?.querySelector('[data-carousel-prev]');
    const next = wrapper?.querySelector('[data-carousel-next]');
    const distance = () => Math.max(carousel.clientWidth * 0.8, 260);
    previous?.addEventListener('click', () => carousel.scrollBy({ left: -distance(), behavior: 'smooth' }));
    next?.addEventListener('click', () => carousel.scrollBy({ left: distance(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-logo-stage]').forEach((stage) => {
    if (stage.dataset.logoTilt !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const layers = stage.querySelectorAll('.floating-logo__inner, .floating-model__inner');
    let frame;
    const reset = () => {
      layers.forEach((layer) => {
        layer.style.setProperty('--tilt-x', '0px');
        layer.style.setProperty('--tilt-y', '0px');
      });
    };
    const surface = stage.closest('.hero-section');
    surface?.addEventListener('pointermove', (event) => {
      const bounds = stage.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        layers.forEach((layer, index) => {
          const depth = 7 + index * 4;
          layer.style.setProperty('--tilt-x', `${x * depth}px`);
          layer.style.setProperty('--tilt-y', `${y * depth}px`);
        });
      });
    });
    surface?.addEventListener('pointerleave', reset);
  });


  const popup = document.querySelector('[data-newsletter-popup]');
  const popupCloseButtons = document.querySelectorAll('[data-newsletter-close]');

  if (popup && !safeStorage.getItem('xarchive-newsletter-dismissed')) {
    window.setTimeout(() => {
      if (!document.body.classList.contains('intro-is-open') && !document.querySelector('[data-preloader]:not([hidden])')) popup.hidden = false;
    }, 2800);

    popupCloseButtons.forEach((button) => {
      button.addEventListener('click', () => {
        popup.hidden = true;
        safeStorage.setItem('xarchive-newsletter-dismissed', 'true');
      });
    });
  }
});
